export const CARBONSCORE = ['a', 'b', 'c', 'd', 'e'];
